import { type ReactNode, type MouseEventHandler } from 'react'
import * as S from './IconButton.styles'

interface IconButtonProps {
  children: ReactNode
  onClick: MouseEventHandler<HTMLDivElement>
}

export default function IconButton({ children, onClick }: IconButtonProps) {
  return <S.Container onClick={onClick}>{children}</S.Container>
}
